import { render } from "./Tarifrechner.vue?vue&type=template&id=02ee1144&scoped=true"
import script from "./Tarifrechner.vue?vue&type=script&lang=js"
export * from "./Tarifrechner.vue?vue&type=script&lang=js"

import "./Tarifrechner.vue?vue&type=style&index=0&id=02ee1144&scoped=true&lang=scss"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/_KLZ-DOSSIERS/81-druckkostenkalkulator/druckkostenkalkulator-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ee1144"]])

export default __exports__